'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FailedToPublish = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.FAILED_TO_PUBLISH), _defineProperty(_Record, 'threadId', null), _defineProperty(_Record, 'channel', null), _defineProperty(_Record, 'message', null), _Record), 'FailedToPublish');

exports.default = FailedToPublish;
module.exports = exports['default'];